import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom"
import { toast } from 'react-toastify';

import './index.css';

import App from './App';
import { persistor, store } from './Pages/ReduxStore/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { skipWaitingAndReload } from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
  <App />
  </PersistGate>
  </Provider>
  </BrowserRouter>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    toast.info("A new version is available. Click to refresh.", {
      autoClose: false,
      closeOnClick: true,
      onClick: () => skipWaitingAndReload(registration),
    });
  },
});

